<template>
    <div v-if="colors.length > 1" class="color-index align-self-center">
        <div class="ob1-color-chips ob1-color-chips-mini">
            <span class="visually-hidden">Groupe de couleurs disponibles non sélectionnables</span>
            <div class="d-flex flex-column">
                <template v-for="color in allColors()">
                    <div
                        :key="color.colorName"
                        class="ob1-color-chip"
                        :style="'background-color: ' + color.code +';'"
                    >
                        <span
                            class="ob1-color-chips-mini-tooltip"
                            v-html="color.colorName"
                        />
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import {ColorSorter} from "../../mixins/ColorSorter";

export default {
    name: "SelectorColorChips",
    mixins: [ColorSorter],
    props: {
        colors: {
            type: Array,
            required: true
        }
    },
    data: function () {
        return {
        }
    },
    methods: {
        allColors: function () {
            const colors = [];
            if (this.colors) {
                for (const color of this.colors) {
                    colors.push(
                        {
                            colorName: color.colorName,
                            code: color.code,
                            inputName: color.inputName
                        });
                }
            }
            return this.sortColors(colors);
        }
    }
}
</script>

<style lang="scss">
@import 'ob1_common', 'ob1_variables', 'msh_mixins';

.color-index {
    width: px-to-rem(22);
    position: absolute;
    z-index: 2;
    right: 94%;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
}

//A supprimer après création du composant pastille couleur en verticale
.ob1-color-chips.ob1-color-chips-mini .ob1-color-chip {
    margin-bottom: px-to-rem(5);
}

</style>
